import React from "react";
import { FontAwesome5 } from "@expo/vector-icons";
import { Icon, IIconProps } from "native-base";

const ListIcon: React.FC<IIconProps> = (props) => (
  <Icon as={FontAwesome5} name="list" {...props} />
);

export default ListIcon;
